import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAuthHeaders } from './customers';

// Define a service using a base URL and expected endpoints
export const categoryApi = createApi({
    reducerPath: 'categoryApi',
    tagTypes: ['Category', 'Collection'],
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        prepareHeaders: getAuthHeaders
    }),
    endpoints: (builder) => ({
        addCategory: builder.mutation({
            query: (data) => ({
                url: `categories/${data.category_name}`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: (result, error, { category_name }) => [{ type: 'Category', category_name }]
        }),
        deleteCategory: builder.mutation({
            query(category_name) {
                return {
                    url: `categories/${category_name}`,
                    method: 'DELETE'
                };
            },
            invalidatesTags: (result, error, category_name) => [{ type: 'Category', category_name }]
        }),
        getCategory: builder.query({
            query: (category_name) => `categories/${category_name}`,
            providesTags: (result, error, category_name) => [{ type: 'Category', category_name }]
        }),
        getCollections: builder.query({
            query: () => `categories/collections`,
            providesTags: (result, error, page) => {
                return result
                    ? [
                          // Provides a tag for each post in the current page,
                          // as well as the 'PARTIAL-LIST' tag.
                          ...result.map(({ category_name }) => ({ type: 'Category', category_name })),
                          { type: 'Collection', id: 'PARTIAL-LIST' }
                      ]
                    : [{ type: 'Collection', id: 'PARTIAL-LIST' }];
            }
        })
    })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useAddCategoryMutation,
    useLazyGetCategoryQuery,
    useGetCategoryQuery,
    useDeleteCategoryMutation,
    useGetCollectionsQuery
} = categoryApi;
